"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hyperapp_1 = require("../../../hyperapp");
const html_text_node_1 = require("../../common/components/html-text-node");
const uikit_e_field_1 = require("../../common/components/uikit-e-field");
const TYPES = {
    warning: {
        icon: 'exclamation-circle',
        color: 'warning',
    },
    info: {
        icon: 'e-info-circle',
        color: 'info',
    },
    error: {
        icon: 'warning',
        color: 'danger',
    },
    default: {
        icon: 'exclamation-circle',
        color: 'warning',
    },
};
exports.ImageWarning = ({ message, type }) => (hyperapp_1.h(uikit_e_field_1.UiKitEField, null,
    hyperapp_1.h("e-icon", { icon: (TYPES[type] || TYPES.default).icon, type: "inline", size: "small", color: (TYPES[type] || TYPES.default).color }),
    hyperapp_1.h(html_text_node_1.HTMLTextNode, { text: message })));
//# sourceMappingURL=image-warning.js.map